import React from 'react';
import {
  Button,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  getPassthroughProps
} from '../componentHelpers';
import formContextAware from './formContextAware.jsx';
import Spinner from '../Spinner.jsx';

class SubmitButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  render() {
    let { className, enabled, isEnabledWhenInvalid, isSubmitting, isSyntheticForm, isValid, isValidating } = this.props;
    return (
      <Button { ...getPassthroughProps(this) }
        disabled={!enabled || isSubmitting || (!isEnabledWhenInvalid && !isValid)}
        onClick={this.handleClick}
        type={isSyntheticForm ? 'button' : 'submit'}
        className={classNames(className, isSubmitting ? 'btn-loading' : null)}
        bsStyle={this.props.bsStyle}
      >
        {this.props.children}
        {isSubmitting ? <Spinner className={this.props.bsStyle} /> : null}
      </Button>
    );
  }

  handleClick(e) {
    if (this.props.isSyntheticForm) {
      this.props.submit();
    }

    if (this.props.isValid) {
      this.props.onClick(e);
    }
  }
}

SubmitButton.propTypes = {
  bsStyle: PropTypes.string,
  className: PropTypes.string,
  enabled: PropTypes.bool,
  isEnabledWhenInvalid: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isSyntheticForm: PropTypes.bool,
  isValid: PropTypes.bool,
  isValidating: PropTypes.bool,
  onClick: PropTypes.func,
  submit: PropTypes.func,
  children: PropTypes.any,
};

SubmitButton.defaultProps = {
  bsStyle: 'primary',
  enabled: true,
  isEnabledWhenInvalid: true,
  isSubmitting: false,
  isSyntheticForm: false,
  isValid: true,
  isValidating: false,
  onClick: () => { },
  submit: () => { },
};

let FormContextAwareSubmitButton = formContextAware(SubmitButton);

export default FormContextAwareSubmitButton;
